import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function PersonalInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      id="personalDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("personalInformation")}
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[20px]">
        <LabelComponent
          title={t("name")}
          subTitle={`${userDetails.firstName || ""} ${
            userDetails.lastName || ""
          }`}
        />
        <LabelComponent
          title={t("nationalityLabel") || t("nationality")}
          subTitle={
            userDetails?.userNationalities?.length > 0
              ? userDetails?.userNationalities
                  .map((elem) => elem.name)
                  .join(", ")
              : "-"
          }
        />

        <LabelComponent
          title={t("phoneNumber")}
          subTitle={userDetails.phoneNumber || userDetails.phone || "-"}
        />
        <LabelComponent
          title={t("email")}
          subTitle={userDetails.email || "-"}
        />

        <LabelComponent
          title={t("personalInformationCountry")}
          subTitle={userDetails.country?.name || "-"}
        />
        <LabelComponent
          title={t("personalInformationCity")}
          subTitle={userDetails.city?.name || "-"}
        />
      </div>
    </div>
  );
}

PersonalInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default PersonalInformation;
